export interface VoiceCallEventDTO {
  Id: string;
  Ani: string;
  AttachData: any;
  CallDirection: VoiceCallDirection;
  CallStatus: VoiceCallEventType;
  DisconectCode: string;
}

export enum VoiceCallDirection {
  Inbound,
  Outbound,
}

export enum VoiceCallEventType {
  Answered,
  Released,
}
